<template>
    <div v-if="isUploading || uploadError" class="upload-feedback">
        <div v-if="isUploading" class="upload-progress-container">
            <div class="progress-bar-bg">
                <div
                    class="progress-bar-fill"
                    :style="{ width: uploadProgress + '%' }"
                ></div>
            </div>
        </div>
        <div v-if="uploadError" class="upload-error-container">
            <span class="error-message">{{ uploadError }}</span>
            <span
                class="icon icon-close material-symbols-outlined"
                @click="clearError"
            >
                close
            </span>
        </div>
    </div>
</template>

<script>
import { useAxiosStore } from "js/stores/axiosStore";
import { mapState, mapActions } from "pinia";

export default {
    name: "UploadFeedback",
    computed: {
        ...mapState(useAxiosStore, [
            "uploadProgress",
            "isUploading",
            "uploadError",
        ]),
    },
    methods: {
        ...mapActions(useAxiosStore, ["clearUploadError"]),
        clearError() {
            this.clearUploadError();
        },
    },
};
</script>
